import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, take, throwError } from 'rxjs';
import { AlertService } from '@app/utility/alert.service';
import { LayoutService } from '@app/layout/layout.service';

/**
 * Global hard-block + upsell: on 403 {error:'feature_not_available', required_plan}
 * show an upgrade toast and route to the CURRENT workspace's billing page
 * (falling back to the profile billing list if no current workspace).
 */
export const featureGate403InterceptorFn: HttpInterceptorFn = (req, next) => {
  const alert = inject(AlertService);
  const router = inject(Router);
  const layout = inject(LayoutService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 403 && err.error?.error === 'feature_not_available') {
        const plan = err.error.required_plan || 'a paid';
        alert.warning(`This feature needs the ${plan} plan. Upgrade to unlock it.`);
        layout.companyId$.pipe(take(1)).subscribe((companyId) => {
          if (companyId != null) { router.navigate(['/companies', companyId, 'billing']); }
          else { router.navigate(['profile', 'billing']); }
        });
      }
      return throwError(() => err);
    }),
  );
};
